export default "__VITE_ASSET__D4Qf2ey___"